import { render } from "./Ventas.vue?vue&type=template&id=44b0d2f0&scoped=true"
import script from "./Ventas.vue?vue&type=script&lang=js"
export * from "./Ventas.vue?vue&type=script&lang=js"

import "./Ventas.vue?vue&type=style&index=0&id=44b0d2f0&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b0d2f0"]])

export default __exports__